import { useDispatch, useSelector } from 'react-redux'

import { useAppContext } from '@/App.context'
import { Translation } from '@/components/i18n/Translation'
import { DispatchTabs } from '@/components/util/Tabs'
import { getStatusCounter, getStatusFilter, setStatusFilter } from '@/ducks/deviceOrdersReducer'
import { numberFormat } from '@/util/formatters/numbers'
import { getDeviceOrderStatusTextId } from '@/util/orders'

import './status-buttons.scss'

const StatusTabs = () => {
  const dispatch = useDispatch()

  const statusCounter = useSelector(getStatusCounter)
  const statusFilter = useSelector(getStatusFilter)
  const { whiteLabel } = useAppContext()
  // @ts-ignore
  const sortFn = (x, y) => x - y
  const keys = Object.keys(statusCounter)
    .map(key => parseInt(key))
    .sort(sortFn)

  const tabs = keys.map(status => ({
    onClick: () => dispatch(setStatusFilter(status)),
    selected: statusFilter === status,
    children: (
      <>
        <Translation id={getDeviceOrderStatusTextId(status, whiteLabel)} />{' '}
        <b>{numberFormat(statusCounter[status])}</b>
      </>
    ),
  }))
  // @ts-ignore
  return <DispatchTabs className="status-tabs" tabs={tabs} />
}

export default StatusTabs
